import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const RestockModal = ({ isOpen, onClose, consumable, onRestock }) => {
  const [quantity, setQuantity] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    const qty = parseInt(quantity);
    if (qty > 0) {
      onRestock(consumable?.id, qty);
    }
  };

  const newStock = consumable?.current_stock + (parseInt(quantity) || 0);
  const willResolveAlert = newStock > consumable?.minimum_threshold;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1020] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="bg-card rounded-lg shadow-lg max-w-md w-full animate-scale-in">
        <div className="p-6 border-b border-border">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-success/10 flex items-center justify-center">
                <Icon name="Plus" size={24} className="text-success" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground">Réapprovisionner</h3>
                <p className="text-sm text-muted-foreground">{consumable?.name}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-lg transition-colors"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="bg-muted/50 rounded-lg p-4 space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Stock actuel</span>
              <span className="text-sm font-medium text-foreground">{consumable?.current_stock}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Seuil minimum</span>
              <span className="text-sm font-medium text-foreground">{consumable?.minimum_threshold}</span>
            </div>
            {consumable?.supplier && (
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Fournisseur</span>
                <span className="text-sm font-medium text-foreground">{consumable?.supplier}</span>
              </div>
            )}
          </div>

          <Input
            label="Quantité à ajouter"
            type="number"
            placeholder="0"
            value={quantity}
            onChange={(e) => setQuantity(e?.target?.value)}
            required
            min="1"
          />

          {quantity && parseInt(quantity) > 0 && (
            <div className="bg-primary/10 border border-primary/20 rounded-lg p-4">
              <div className="flex items-start gap-2">
                <Icon name="Info" size={16} className="text-primary mt-0.5" />
                <div className="text-xs text-primary">
                  <p className="font-medium mb-1">Nouveau stock</p>
                  <p>Stock après réapprovisionnement: <strong>{newStock}</strong></p>
                  {willResolveAlert && (
                    <p className="mt-1 text-success">✓ L'alerte de stock faible sera automatiquement résolue</p>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              variant="default"
              iconName="Plus"
              className="flex-1"
              disabled={!quantity || parseInt(quantity) <= 0}
            >
              Confirmer
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RestockModal;